module.exports = __webpack_public_path__ + "static/media/pulverizador.2d5f6ca7.svg";